export default __webpack_public_path__ + "static/dubai-skyline-aacd1deedc055c907c7a9072323f3833.webp";